<template>
    <div></div>
</template>

<script>
  export default {
    name: "Callback",
    mounted() {
      this.$authService.handleAuthentication();
    }
  }
</script>

<style scoped>

</style>